"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostMaintenanceEndResponse = instanceOfApiPostMaintenanceEndResponse;
exports.ApiPostMaintenanceEndResponseFromJSON = ApiPostMaintenanceEndResponseFromJSON;
exports.ApiPostMaintenanceEndResponseFromJSONTyped = ApiPostMaintenanceEndResponseFromJSONTyped;
exports.ApiPostMaintenanceEndResponseToJSON = ApiPostMaintenanceEndResponseToJSON;
exports.ApiPostMaintenanceEndResponseToJSONTyped = ApiPostMaintenanceEndResponseToJSONTyped;
/**
 * Check if a given object implements the ApiPostMaintenanceEndResponse interface.
 */
function instanceOfApiPostMaintenanceEndResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ApiPostMaintenanceEndResponseFromJSON(json) {
    return ApiPostMaintenanceEndResponseFromJSONTyped(json, false);
}
function ApiPostMaintenanceEndResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
function ApiPostMaintenanceEndResponseToJSON(json) {
    return ApiPostMaintenanceEndResponseToJSONTyped(json, false);
}
function ApiPostMaintenanceEndResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
